import { Layout } from '@/modules/shared/layouts/layout'

import { useCustomerProfile } from '../hooks/use-customer-profile.hook'
import { CustomerProfileInterface } from '../interfaces/customer-profile.interface'

export function CustomerProfileContainer() {
	const clientProfileHook = useCustomerProfile()

	return (
		<Layout
			pageTitle="Perfil do cliente"
			handleGoBack={clientProfileHook.handleBackPage}
		>
			<CustomerProfileInterface {...clientProfileHook} />
		</Layout>
	)
}
